// CategoryBox.jsx
import React from 'react';

const CategoryBox = ({ category, position }) => {

  const getRatingColor = (rating) => {
    if (rating >= 4.5) return ['#16a34a', '#22c55e']; // Darker green to green
    if (rating >= 4) return ['#22c55e', '#4ade80']; // Green to light green
    if (rating >= 3.5) return ['#f59e0b', '#fbbf24']; // Amber to yellow
    if (rating >= 3) return ['#f97316', '#fb923c']; // Orange to light orange
    return ['#dc2626', '#ef4444']; // Dark red to red
  };

  /*linear-gradient(45deg, #ff6b6b, #ffd93d);*/

  const getGradient = (rating) => {
    const [start, end] = getRatingColor(rating);
    return `linear-gradient(45deg, ${start}, ${end})`;
  };

  const ratingGradient = getGradient(category.rating);

  return (
    <div className={`category-card ${position}`}>
      <h2 className="text-xl font-bold text-center mb-4">
        {category.name}
      </h2>
      <div className="category-rating" style={{ 
        backgroundImage: ratingGradient, 
        WebkitBackgroundClip: 'text', 
        color: 'transparent' 
      }}>
        {category.rating} {/* added toFixed(1) back */}
      </div>
      <p className="text-center text-opacity-80">
        {category.totalResponses} responses
      </p>
    </div>
  );
};

export default CategoryBox;